<template>
  <div class="event-list-page">
    <div class="go-back">
      <el-button class="row go-back-btn" icon="el-icon-arrow-left" @click="goBack"></el-button>
    </div>
    <div class="body">
      <div class="title">热门事件</div>
      <event-list class="event-list" @change="sourceHome"></event-list>
    </div>
  </div>
</template>

<script>
import EventList from '@/components/news-monitor/EventList';

export default {
  data() {
    return {
      source: ''
    };
  },
  components: {
    EventList
  },
  methods: {
    goBack() {
      if (this.source) {
        this.$router.push({
          name: 'monitor-home'
        });
      } else {
        this.$router.push({
          name: 'main-page'
        });
      }
    },
    sourceHome(res) {
      this.source = res;
    }
  }
};
</script>

<style lang="scss" scoped>
.event-list-page {
  position: relative;
  padding: 32px 88px;
  background-color: #343239;
  .go-back {
    position: fixed;
    left: 32px;
    top: 96px;
    .go-back-btn {
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      padding: 0;
      font-size: 22px;
      background-color: #3b3a3f;
      color: #ffffff80;
      border: none;
      border-radius: 4px;
      &:hover {
        background-color: #3b3a3f;
        color:#ffffff;
      }
    }
  }
  .body {
    width:1002px;
    margin: 0 auto;
    .title {
      font-size: 32px;
      color: #ffffff;
      line-height: 45px;
    }
    .event-list {
      margin-top: 40px;
    }
  }
}
</style>

